'use client';

import { BigNum, PRICE_PRECISION_EXP } from '@velocity-exchange/sdk';
import { UIMarket } from '@velocity-exchange/common';
import ValueChangeBlink from 'src/components/Utils/ValueChangeBlink';
import NumberDisplay, {
	HIDDEN_ACCOUNT_VALUE_TEXT,
} from 'src/components/NumberDisplay/NumberDisplay';
import { getMarketPriceDecimals } from 'src/constants/marketDecimalConfig';
import { PRICE_FALLBACK_DISPLAY_VALUE } from 'src/components/TradeForm/consts';
import useShowAccountValues from 'src/hooks/useShowAccountValues';
import { AccountOpenPosition } from 'src/@types/positions';
import { PRESETS, withDecimals } from 'src/utils/formatNumber/presets';
import { formatText } from '@velocity-exchange/common/format';

interface LiqPriceCellProps {
	position: AccountOpenPosition;
}

export function LiqPriceCell({ position }: LiqPriceCellProps) {
	const { liqPrice, marketIndex, isIsolatedBalanceOnly } = position;

	const showAccountValues = useShowAccountValues();

	if (isIsolatedBalanceOnly) {
		return <span className="text-text-secondary">-</span>;
	}

	const uiMarket = UIMarket.createPerpMarket(marketIndex);
	const liqPriceBigNum = BigNum.from(liqPrice, PRICE_PRECISION_EXP);

	return (
		<ValueChangeBlink
			value={
				showAccountValues
					? formatText(liqPriceBigNum, PRESETS.usdTradePrecision)
					: HIDDEN_ACCOUNT_VALUE_TEXT
			}
		>
			{showAccountValues ? (
				liqPriceBigNum.lteZero() ? (
					PRICE_FALLBACK_DISPLAY_VALUE
				) : (
					<NumberDisplay
						value={liqPriceBigNum}
						options={withDecimals(
							PRESETS.usdTruncate,
							getMarketPriceDecimals(uiMarket.uiSymbols.baseAssetSymbol)
						)}
					/>
				)
			) : (
				HIDDEN_ACCOUNT_VALUE_TEXT
			)}
		</ValueChangeBlink>
	);
}
